__turbopack_context__.v({
  "cards": "BsZb7a_cards",
  "count": "BsZb7a_count",
  "desktopFilter": "BsZb7a_desktopFilter",
  "desktopFilterApply": "BsZb7a_desktopFilterApply",
  "desktopFilterReset": "BsZb7a_desktopFilterReset",
  "desktopSort": "BsZb7a_desktopSort",
  "heading": "BsZb7a_heading",
  "layout": "BsZb7a_layout",
  "loadMore": "BsZb7a_loadMore",
  "loadMoreWrapper": "BsZb7a_loadMoreWrapper",
  "mobileFilterApply": "BsZb7a_mobileFilterApply",
  "mobileFilterClose": "BsZb7a_mobileFilterClose",
  "mobileFilterCloseIcon": "BsZb7a_mobileFilterCloseIcon",
  "mobileFilterFooter": "BsZb7a_mobileFilterFooter",
  "mobileFilterHeader": "BsZb7a_mobileFilterHeader",
  "mobileFilterIcon": "BsZb7a_mobileFilterIcon",
  "mobileFilterReset": "BsZb7a_mobileFilterReset",
  "mobileFilterScroll": "BsZb7a_mobileFilterScroll",
  "mobileFilterScrollTail": "BsZb7a_mobileFilterScrollTail",
  "mobileFilterSheet": "BsZb7a_mobileFilterSheet",
  "mobileFilterTitle": "BsZb7a_mobileFilterTitle",
  "mobileFilterTrigger": "BsZb7a_mobileFilterTrigger",
  "mobileSortTrigger": "BsZb7a_mobileSortTrigger",
  "mobileToolbar": "BsZb7a_mobileToolbar",
  "pageContent": "BsZb7a_pageContent",
  "results": "BsZb7a_results",
  "resultsHeader": "BsZb7a_resultsHeader",
  "section": "BsZb7a_section",
  "state": "BsZb7a_state",
  "stateAction": "BsZb7a_stateAction",
});
